import {DateTime} from 'luxon';

import {PSSCENE_IMAGERY_CAPABILITIES_ASSETS} from '@explorer/constants/asset-types';
import {ITEM_TYPES} from '@explorer/constants/item-types';

export function getUniqueId(item) {
  return `${item.properties.item_type}:${item.properties.item_id || item.id}`;
}

export const getUniqueIdItems = items =>
  items.map(item => getUniqueId(item)).join();

export function getResultId(item) {
  const day = DateTime.fromISO(item.properties.acquired, {zone: 'utc'}).startOf(
    'day'
  );

  return `${item.properties.item_type}:${day.valueOf()}`;
}

export function getResolution(item) {
  return item.properties.pixel_resolution || item.properties.gsd;
}

export const itemTypeSupported = itemType => {
  const itemTypes = Object.values(ITEM_TYPES);

  return itemTypes.includes(itemType);
};

/**
 * Calculate the asset to use in the PSScene asset filter from
 * the currently selected capabilities
 * @param {array} capabilities - An array of IMAGERY_CAPABILITIES
 * @returns {string} asset type - The minimum asset type for the selected capability
 */
const calcPSSceneAssetFilterFromCapabilities = capabilities => {
  return capabilities.map(cap => PSSCENE_IMAGERY_CAPABILITIES_ASSETS[cap]);
};

/**
 * Generate search filters for PSScene items
 * @param {array} capabilities - An array of IMAGERY_CAPABILITIES
 * @return {object} search filter - A Search filter object
 * @requires module:@explorer/constants/asset-types.js/PSSCENE_IMAGERY_CAPABILITIES_ASSETS
 * @requires module:@explorer/constants/item-types.js/ITEM_TYPES
 */
export const generatePSSceneSearchFilter = capabilities => {
  // Calculate the asset to filter by
  const PSSceneAssetFilters =
    calcPSSceneAssetFilterFromCapabilities(capabilities);

  const config = [
    {
      type: 'StringInFilter',
      field_name: 'item_type',
      config: [ITEM_TYPES.PSSCENE],
    },
  ];

  // Don't use the asset filter for "Visual" capability, since all results have visual capability
  // and we don't want to add the overhead cost of using the asset filter in the search query
  // since it will make no difference
  if (PSSceneAssetFilters.length) {
    config.push({
      type: 'AndFilter',
      config: PSSceneAssetFilters.map(filter => ({
        type: 'AssetFilter',
        config: [filter],
      })),
    });
  }

  return {
    type: 'AndFilter',
    config: config,
  };
};
